import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import SignInForm from '../components/auth/SignInForm';
import Layout from '../components/layout/Layout';
import { useAuth } from '../hooks/useAuth';

const SignIn: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if user is already signed in
  useEffect(() => {
    if (currentUser && !loading) {
      navigate('/my-wheels');
    }
  }, [currentUser, loading, navigate]);

  // Handle successful sign in
  const handleSuccess = () => {
    navigate('/my-wheels');
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
          <SignInForm onSuccess={handleSuccess} />
        </div>
      </div>
    </Layout>
  );
};

export default SignIn;
